import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AppProvider from './context/AppContext';
import MainLayout from './components/layout/Main';
import Home from './pages/Home';
import "./scss/index.scss"
import WHOISTools from './pages/WHOISTools';
import AppraisalTool from './pages/AppraisalTool';
import Services from './pages/Services';
import Featured from './pages/Featured';
import ServiceIndividual from './pages/ServiceIndividual';
import DomainBrokerService from './pages/DomainBroker';
import ConsultationsService from './pages/Consultation';
import DomainPortfolioManagementPage from './pages/PortfolioManagement';
import DirectAcquisitionsPage from './pages/DirectAcquisitions';
import MarketingDesignPage from './pages/Marketing';
import TermsPage from './pages/Terms';
import PrivacyPage from './pages/Privacy';
import TransferAgreementPage from './pages/TransferAgreement';
import BrokerageAgreementPage from './pages/BrokerageAgreement';
import ScrollToTop from './components/ScrollToTop';
import Contact from './pages/Contact';
import ResourcesPage from './pages/Resources';
import AboutPage from './pages/About';
import DomainAcquisitionService from './pages/DomainAcquisition';
import DomainAppraisalsPage from './pages/DomainAppraisal';
import DomainAcquisitionNew from './pages/DomainAcquisitionNew';

/**
 * Main App component with routing
 * @returns {JSX.Element} App component
 */
const App = () => {
  return (
    <Router>
      <AppProvider>
        <MainLayout>
          <ScrollToTop />
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Home />} />
            <Route path="/tool" element={<WHOISTools />} />
            <Route path="/tool/whois" element={<WHOISTools />} />
            <Route path="/tool/appraisal" element={<AppraisalTool />} />
            <Route path="/services" element={<Services />} />
            {/* <Route path="/services/test-service" element={<ServiceIndividual />} /> */}
            {/* <Route path="/services/domain-acquisition" element={<DomainAcquisitionService />} /> */}
            <Route path="/services/domain-acquisition" element={<DomainAcquisitionNew />} />
            <Route path="/services/domain-appraisals" element={<DomainAppraisalsPage />} />

            <Route path="/services/domain-brokering" element={<DomainBrokerService />} />
            <Route path="/services/consulting" element={<ConsultationsService />} />
            <Route path="/services/strategy" element={<DomainPortfolioManagementPage />} />
            {/* <Route path="/services/discreet-acquisitions" element={<DirectAcquisitionsPage />} /> */}
            <Route path="/services/marketing-design" element={<MarketingDesignPage />} />
            
            {/* <Route path="/services/domain-acquisition" element={<DomainAcquisitionService />} /> */}
            <Route path="/resources" element={<ResourcesPage />} />

            <Route path="/domains-for-sale" element={<Featured />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/brokerage-agreement" element={<BrokerageAgreementPage />} />
            <Route path="/transfer-agreement" element={<TransferAgreementPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </MainLayout>
      </AppProvider>
    </Router>
  );
};

export default App;